module.exports = __webpack_public_path__ + "img/nodeType1.a0761dc1.svg";